import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.small";
import "core-js/modules/es6.regexp.split";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/stars.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/flowers.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/leaf.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/eyes.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/asterisks.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/bleaf.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/ball-of-wool.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/log-of-wood.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/footprint.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/moon.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/oak-leaf.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/spall.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/branch.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/dragonfly.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/deer.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/pine-cone.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/snowflake-blue.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/candle-white.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/holly-pink.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cup.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/palm.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/oak-leaf-white.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/champagne.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cup-of-coffee.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/christmas-ball.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/palm-grove01.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/palm-grove02.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/paper-shop01.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/paper-shop02.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/paradise01.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/paradise02.svg';
import UrlParse from 'url-parse';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import TrendMainImage from '~/components/molecules/Editorial/Trend/TrendMainImage.vue';
import TrendNavigation from '~/components/molecules/Editorial/Trend/TrendNavigation.vue';
export default {
  name: 'TrendingHeaderOrganism',
  components: {
    TrendMainImage: TrendMainImage,
    TrendNavigation: TrendNavigation
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17;

      var next = new UrlParse(((_ref17 = this.payload) != null ? (_ref17 = _ref17.primary) != null ? (_ref17 = _ref17.next_url) != null ? _ref17.url : _ref17 : _ref17 : _ref17) || '');
      var nextArr = _typeof(next) === 'object' ? next.pathname.split('/') : false;
      var nextSlug = nextArr[nextArr.length - 1];
      var previous = new UrlParse(((_ref16 = this.payload) != null ? (_ref16 = _ref16.primary) != null ? (_ref16 = _ref16.previous_url) != null ? _ref16.url : _ref16 : _ref16 : _ref16) || '');
      var previousArr = _typeof(previous) === 'object' ? previous.pathname.split('/') : false;
      var previousSlug = previousArr[previousArr.length - 1];
      var commonTracking = {
        event_category: this.payload.primary.tracking_event_category,
        event_action: this.payload.primary.tracking_event_action
      };
      return {
        mainImage: {
          position: ((_ref15 = this.payload) != null ? (_ref15 = _ref15.primary) != null ? _ref15.position : _ref15 : _ref15) || '',
          released: this.released,
          subhead: ((_ref14 = this.payload) != null ? (_ref14 = _ref14.primary) != null ? _ref14.subhead : _ref14 : _ref14) || '',
          title: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? (_ref13 = _ref13.title) != null ? (_ref13 = _ref13[0]) != null ? _ref13.text : _ref13 : _ref13 : _ref13 : _ref13) || '',
          label: ((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? _ref12.label : _ref12 : _ref12) || '',
          color: ((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? _ref11.primary_color : _ref11 : _ref11) || '',
          fontColor: ((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? _ref10.font_color : _ref10 : _ref10) || '',
          image: {
            small: formatPrismicImage((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? (_ref9 = _ref9.image) != null ? (_ref9 = _ref9.small) != null ? _ref9.url : _ref9 : _ref9 : _ref9 : _ref9, ['w_375']) || EMPTY_PIXEL,
            medium: formatPrismicImage((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? (_ref8 = _ref8.image) != null ? (_ref8 = _ref8.small) != null ? _ref8.url : _ref8 : _ref8 : _ref8 : _ref8, ['w_375,dpr_2']) || EMPTY_PIXEL,
            large: formatPrismicImage((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? (_ref7 = _ref7.image) != null ? (_ref7 = _ref7.large) != null ? _ref7.url : _ref7 : _ref7 : _ref7 : _ref7, ['w_1440']) || EMPTY_PIXEL,
            xlarge: formatPrismicImage((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? (_ref6 = _ref6.image) != null ? (_ref6 = _ref6.large) != null ? _ref6.url : _ref6 : _ref6 : _ref6 : _ref6, ['w_1440,dpr_2']) || EMPTY_PIXEL
          }
        },
        navigation: {
          color: ((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? _ref5.secondary_color : _ref5 : _ref5) || '',
          name: ((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? _ref4.name : _ref4 : _ref4) || '',
          next: {
            url: next.pathname,
            text: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.next_text : _ref3 : _ref3) || '',
            slug: nextSlug,
            tracking: {
              data: _objectSpread({}, commonTracking, {
                event_label: this.payload.primary.tracking_event_label_next
              })
            }
          },
          previous: {
            url: previous.pathname,
            text: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.previous_text : _ref2 : _ref2) || '',
            slug: previousSlug,
            tracking: {
              data: _objectSpread({}, commonTracking, {
                event_label: this.payload.primary.tracking_event_label_previous
              })
            }
          }
        }
      };
    },
    released: function released() {
      var _ref;

      var releaseDate = new Date(((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.release : _ref : _ref) || '');
      var currentDate = new Date();
      return currentDate.getTime() > releaseDate.getTime();
    }
  }
};